module.exports = __webpack_public_path__ + "static/media/vocals.7db3d0d9.mp3";